import { useStaffIsAgencyTaskWhitelisted } from '@urbanx/agx.activities.client';
import { AgxNotificationBox, AgxSpacer } from '@urbanx/agx.ui-components2';
import { useParams } from 'react-router-dom';

const TaskWhitelistWarning = () => {
  const { agencyId } = useParams();
  const { data: isWhitelisted } = useStaffIsAgencyTaskWhitelisted(agencyId!, !!agencyId);

  if (isWhitelisted !== false) return null;

  return (
    <AgxSpacer fill padding={{ top: 'spacing-3xl' }}>
      <AgxNotificationBox
        type="warning"
        heading="Agency is not on the tasks whitelist"
        body="This agency is not explicitly included on the tasks whitelist. The tasks module will not work correctly for this agency."
      />
    </AgxSpacer>
  );
};

export default TaskWhitelistWarning;
